import { useEffect, useState } from 'react';

export default function useCompactLayout(containerRef, breakpoint = 768) {
  const [isCompactLayout, setIsCompactLayout] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const updateCompactLayout = () => {
      const width = containerRef.current?.getBoundingClientRect().width ?? window.innerWidth;
      setIsCompactLayout(width < breakpoint);
    };

    updateCompactLayout();
    window.addEventListener('resize', updateCompactLayout);

    let observer;
    if (typeof ResizeObserver !== 'undefined' && containerRef.current) {
      observer = new ResizeObserver(updateCompactLayout);
      observer.observe(containerRef.current);
    }

    return () => {
      window.removeEventListener('resize', updateCompactLayout);
      observer?.disconnect();
    };
  }, [breakpoint, containerRef]);

  return isCompactLayout;
}
